<template>
  <div class="contents">
    <div class="container email-templates-container">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb-main user-member justify-content-sm-between">
            <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
              <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                <div>
                  <h4 class="text-capitalize fw-500 breadcrumb-title mb-0">Email Notification Templates</h4>
                  <p class="text-muted mb-0">Configure system email templates</p>
                </div>
              </div>
            </div>
            <div class="action-btn d-flex">
              <button type="button" class="btn btn-light border mr-2" @click="migrateTemplates" :disabled="migrating">
                Migrate Templates
              </button>
              <router-link to="/admin/email-template/new" class="btn btn-primary">
                New Template
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
            <EmailTemplateTable />
          </div>
        </div>
      </div>
      <modal name="email_blast" :height="'auto'" :adaptive="true" :scrollable="true">
        <div style="margin: 20px">
          <h5>Blast Email</h5>
          <p v-if="blastTemplate"><strong>{{ blastTemplate.name }}</strong></p>
          <label>Pilih User</label>
          <multiselect
            v-model="blastUsers"
            :options="userOptions"
            :multiple="true"
            :close-on-select="false"
            label="label"
            track-by="id"
            placeholder="Cari user..."
          />
          <br>
          <button type="button" class="btn btn-primary btn-block" :disabled="blasting || !blastUsers.length" @click="sendBlast">
            <span v-if="blasting"><i class="fas fa-spinner fa-spin"></i> Mengirim...</span>
            <span v-else>Kirim Email</span>
          </button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import EmailTemplateTable from '@/components/tables/EmailTemplate.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: { EmailTemplateTable, Multiselect },
  data() {
    return {
      migrating: false,
      blasting: false,
      blastTemplate: null,
      blastUsers: [],
      userOptions: [],
    }
  },
  mounted() {
    this.$root.$on('open_email_blast', this.openBlast)
  },
  beforeDestroy() {
    this.$root.$off('open_email_blast', this.openBlast)
  },
  methods: {
    async openBlast(template) {
      this.blastTemplate = template
      this.blastUsers = []
      if (!this.userOptions.length) {
        try {
          const res = await this.$store.dispatch('admin_user_list', { page: 1, limit: 1000 })
          const users = res.data.data.users || []
          this.userOptions = users
            .filter(u => u.email)
            .map(u => ({ id: u.id, label: `${u.name || u.email} (${u.email})` }))
        } catch (err) {
          this.$toast.error('Gagal memuat daftar user')
          return
        }
      }
      this.$modal.show('email_blast')
    },
    async sendBlast() {
      if (!this.blastTemplate || !this.blastUsers.length) return
      this.blasting = true
      try {
        const response = await this.$store.dispatch('admin_email_blast', {
          template_id: this.blastTemplate.id,
          user_ids: this.blastUsers.map(u => u.id),
        })
        const data = response.data.data
        this.$toast.success(`${response.data.message}: ${data.sent} terkirim, ${data.failed} gagal`)
        this.$modal.hide('email_blast')
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Blast gagal')
      }
      this.blasting = false
    },
    async migrateTemplates() {
      this.migrating = true
      try {
        const response = await this.$store.dispatch('admin_email_migrate_templates')
        this.$toast.success(response.data.message + ` (${response.data.data.inserted} baru)`)
        this.$root.$emit('refresh_email_template_table')
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Migrasi gagal')
      }
      this.migrating = false
    },
  },
}
</script>
